module.exports = __webpack_public_path__ + "static/media/caros-thin-italic.2e755ae2.woff";